import { SurveySegmentation } from '.';
import { LanguageCode } from '.';

export const SurveyTypes = ['WPA', 'Pulse'] as const;
export type SurveyType = typeof SurveyTypes[number];

export type Survey =
SurveyData &
{
    answerCount: number;
    finishedAnswerCount: number
};

// start and end is read from referenced Activity
export type SurveyData =
{
    id:string,
    activityId:string,
    type: SurveyType,
    title: string,
    introduction:SurveyIntroduction,
    start: Date,
    end: Date;
    languageCode: LanguageCode,
    translationLanguages:LanguageCode[],
    segmentations: SurveySegmentation[],
    themes: SurveyTheme[]
};

export type SurveyListing =
{
    id:string,
    type: SurveyType,
    title: string,
    start: Date,
    end: Date,
    languageCode:LanguageCode,
    answerCount: number,
    finishedAnswerCount: number
}

export type LocalizedSurveyText = 
{
    languageCode:LanguageCode,
    text:string
}

export type SurveyIntroduction = 
{
    text:string,
    translations:LocalizedSurveyText[]
};

export type SurveyTheme =
{
    name:string,
    translations:LocalizedSurveyText[],
    questions: SurveyQuestion[]
}

// Questions are all have 1-5 values as options.
export type SurveyQuestion =
    {
        indicators: string[],
        title:string,
        translations:LocalizedSurveyText[],
        canComment: boolean,
        invertScore?: boolean
    }

export type SurveyStatus = 
    {
        access: 'waiting' | 'open' | 'closed',
        canEdit: boolean,
        hasQuestions: boolean,
        canSubmitAnswer: boolean,
        warning: '' | 'empty theme(s)'
    }

